/* eslint-disable func-names */
import * as yup from 'yup';
import dayjs from 'dayjs';
import { parseNumber } from 'helper';

export const initialValues = {
  title: '',
  amount: '',
  status: '',
  amount_type: 'BND',
  minimum_range_amount: '',
  maximum_range_amount: '',
  validity_start_date: '',
  validity_end_date: '',
};

export const VALIDATIONS = {
  DATE_SHOULD_NOT_BE_PAST:
    ('validity_start_date',
    {
      is: (val) => val,
      then: yup
        .string()
        .test('date-validation', 'End date should not be in past', function () {
          const v = this.parent;
          return (
            dayjs(v?.validity_end_date).isAfter(
              dayjs(v?.validity_start_date)
            ) ||
            dayjs(v?.validity_end_date).isSame(dayjs(v?.validity_start_date))
          );
        }),
      otherwise: yup.string(),
    }),
  AMOUNT_SHOULD_NOT_BE_GREATER:
    ('maximum_range_amount',
    {
      is: (val) => val,
      then: yup
        .string()
        .test(
          'amount-validation',
          'Min. amount should not be greater than max amount',
          function () {
            const v = this.parent;
            return (
              parseNumber(v?.minimum_range_amount) <=
              parseNumber(v?.maximum_range_amount)
            );
          }
        ),
      otherwise: yup.string(),
    }),
};
